import { Container, styled } from "@mui/material";
import * as React from "react";

export const PageContainer = styled(Container)(({ theme }) => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return {
        paddingTop: theme.spacing(2),
        paddingBottom: "10rem",
        minHeight: "90vh",
    };
});
